@if (data && billing) {
  <div class="r-company-wrapper">
    <mat-accordion>
      <mat-expansion-panel (opened)="onCompanyPanelOpened()" (closed)="onCompanyPanelClosed()"
        [expanded]="companyPanelOpenState">
        <mat-expansion-panel-header class="header-panel">
          <mat-panel-title class="title-panel">
            <h2 class="header-title">Billing/Reporting information</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-container">
          <h3 class="header-title">Reporting information</h3>
          <div class="item">
            <div class="text">
              <div class="label">Company Name</div>
              <div class="name">{{ data.name }}</div>
            </div>
          </div>
          <div class="item">
            <div class="text">
              <div class="label">Contact Name</div>
              <div class="name">{{ data.contactName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="text">
              <div class="label">Contact email(s) - Report Submittal</div>
              <div class="name">{{ data.emails }}</div>
            </div>
          </div>
          <div class="item">
            <div class="text">
              <div class="label">Address</div>
              <div class="name">{{ getCompanyAddress() }}</div>
            </div>
          </div>
        </div>
        <hr class="divider" />
        <div class="panel-container">
          <h3 class="header-title">Billing Infomation</h3>
          <div class="item">
            <div class="text">
              <div class="label">Company Name</div>
              <div class="name">{{ billing.invoice }}</div>
            </div>
          </div>
          <div class="item">
            <div class="text">
              <div class="label">Contact Name</div>
              <div class="name">{{ billing.contactName }}</div>
            </div>
          </div>
          <div class="item" >
            <div class="text">
              <div class="label">Contact email(s) - Invoice Submittal</div>
              <div class="name">{{ billing.emails }}</div>
            </div>
          </div>
          <div class="item">
            <div class="text">
              <div class="label">Address</div>
              <div class="name">{{ getBillingAddress() }}</div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="note-section">
      <mat-accordion>
        <mat-expansion-panel (opened)="onNotesPanelOpened()" (closed)="onNotesPanelClosed() " [expanded]="notesPanelOpenState">
          <mat-expansion-panel-header class="header-panel">
            <mat-panel-title class="title-panel">
              <h2 class="header-title">Notes</h2>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="panel-container">
            <mat-label>History</mat-label>
            <form #noteForm="ngForm" class="note">
              <mat-dialog-content>
                <div class="row">
                  @if (notes) {
                    <div class="col-12 notes">
                      @for (note of notes; track note) {
                        <div>
                          <mat-label class="mat-subtitle-2 bold-title">
                            {{ note?.updatedBy?.firstName }} {{ note?.updatedBy?.lastName }}:
                            @if (note.createdAt) {
                              <span>
                                {{ note.createdAt | utcToLocal : 'date' }} {{ note.createdAt | utcToLocal : 'time' }}
                              </span>
                            }
                          </mat-label>
                          <div>
                            <span class="mat-subtitle-2 notes-text">
                              {{ note?.text }}
                            </span>
                          </div>
                        </div>
                      }
                      @if (notes?.length === 0) {
                        <div>
                          <p class="truncate-label">No notes available.</p>
                        </div>
                      }
                    </div>
                  }
                  @if (this.userService?.roleCheck(['Labtech', 'Manager', 'Admin'])) {
                    <div class="col-12 mt-16">
                      <mat-label class="mat-subtitle-2">New Notes<span class="required">*</span></mat-label>
                      <mat-form-field appearance="outline" class="text-area">
                        <!-- TODO : Move this logic written in onInput to ts file  -->
                        <textarea
                          class="textarea-popup"
                          matInput
                          rows="3"
                          name="additionalNotes"
                          [(ngModel)]="additionalNotes"
                          maxlength="500"
                          required
                          placeholder="Max 500 characters"
                        (input)="onInputChange($event)"></textarea>
                      </mat-form-field>
                    </div>
                  }
                </div>
              </mat-dialog-content>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}
